// Collection: Filter drawer, sort, grid toggle, load more
(function() {
  // --- Filter Drawer ---
  var drawer = document.querySelector('[data-filter-drawer]');
  var openBtn = document.querySelector('[data-filter-open]');
  var closeBtns = document.querySelectorAll('[data-filter-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  closeBtns.forEach(function(btn) { btn.addEventListener('click', closeDrawer); });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // --- Apply Filters ---
  var applyBtn = document.querySelector('[data-filter-apply]');
  if (applyBtn) {
    applyBtn.addEventListener('click', function() {
      var form = document.getElementById('CollectionFilters');
      if (!form) return;

      var formData = new FormData(form);
      var params = new URLSearchParams();

      for (var pair of formData.entries()) {
        if (pair[1]) params.append(pair[0], pair[1]);
      }

      // Preserve an explicit sort choice; don't inject the default into the URL
      var sortSelect = document.querySelector('[data-sort-select]');
      var currentSort = new URLSearchParams(window.location.search).get('sort_by');
      if (sortSelect && sortSelect.value && (currentSort || sortSelect.value !== sortSelect.options[0].value)) {
        params.set('sort_by', sortSelect.value);
      }

      window.location.search = params.toString();
    });
  }

  // --- Sort ---
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location = url;
    });
  }

  // --- Grid Toggle ---
  var gridToggle = document.querySelector('[data-grid-toggle]');
  var productGrid = document.querySelector('[data-product-grid]');

  if (gridToggle && productGrid) {
    var savedCols = localStorage.getItem('grid-cols');
    if (savedCols === '3') {
      productGrid.classList.add('product-grid--3col');
      updateGridBtns('3');
    }

    gridToggle.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-grid-cols]');
      if (!btn) return;
      var cols = btn.dataset.gridCols;

      if (cols === '3') {
        productGrid.classList.add('product-grid--3col');
      } else {
        productGrid.classList.remove('product-grid--3col');
      }

      localStorage.setItem('grid-cols', cols);
      updateGridBtns(cols);
    });
  }

  function updateGridBtns(activeCols) {
    if (!gridToggle) return;
    gridToggle.querySelectorAll('[data-grid-cols]').forEach(function(btn) {
      btn.classList.toggle('sticky-bar__grid-btn--active', btn.dataset.gridCols === activeCols);
    });
  }

  // --- Brand/Filter Search ---
  document.querySelectorAll('[data-filter-search]').forEach(function(input) {
    var list = input.closest('.filter-drawer__group-body').querySelector('[data-filter-list]');
    if (!list) return;
    input.addEventListener('input', function() {
      var query = input.value.toLowerCase();
      list.querySelectorAll('[data-filter-value]').forEach(function(item) {
        item.hidden = query && item.dataset.filterValue.indexOf(query) === -1;
      });
    });
  });

  // --- Load More ---
  var loadMoreBtn = document.querySelector('[data-load-more]');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', async function() {
      var nextUrl = loadMoreBtn.dataset.nextUrl;
      if (!nextUrl) return;

      loadMoreBtn.textContent = 'Loading...';
      loadMoreBtn.disabled = true;

      try {
        var res = await fetch(nextUrl);
        var html = await res.text();
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newProducts = doc.querySelectorAll('[data-product-grid] .product-card');
        var grid = document.querySelector('[data-product-grid]');
        newProducts.forEach(function(card) { grid.appendChild(card); });

        var totalShowing = grid.querySelectorAll('.product-card').length;
        var newPagination = doc.querySelector('[data-pagination]');
        var currentPagination = document.querySelector('[data-pagination]');

        if (newPagination && currentPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
          var info = currentPagination.querySelector('.collection-pagination__info');
          var totalMatch = info && info.textContent.match(/of (\d+)/);
          if (info && totalMatch) {
            info.textContent = "You've viewed " + totalShowing + ' of ' + totalMatch[1] + ' products';
          }
          var progress = currentPagination.querySelector('.collection-pagination__progress');
          if (progress && totalMatch) {
            progress.style.width = Math.min((totalShowing / parseInt(totalMatch[1], 10)) * 100, 100) + '%';
          }
        } else if (currentPagination && !newPagination) {
          var info2 = currentPagination.querySelector('.collection-pagination__info');
          if (info2) info2.textContent = "You've viewed all " + totalShowing + ' products';
          var progress2 = currentPagination.querySelector('.collection-pagination__progress');
          if (progress2) progress2.style.width = '100%';
          var btn = currentPagination.querySelector('[data-load-more]');
          if (btn) btn.remove();
        }
      } catch (err) {
        loadMoreBtn.textContent = 'Load More';
        loadMoreBtn.disabled = false;
      }
    });
  }
})();
